import React from 'react';

import classes from './DateIndicator.module.css';

const DateIndicator: React.FC<{
    date: Date;
    className: string;
    fullDate?: boolean;
}> = props => {
    const day = props.date.getDate().toString().padStart(2, '0');
    const month = (props.date.getMonth() + 1).toString().padStart(2, '0'); // getMonth returns from 0
    const year = props.date.getFullYear();
    const hours = props.date.getHours().toString().padStart(2, '0');
    const minutes = props.date.getMinutes().toString().padStart(2, '0');
    const seconds = props.date.getSeconds().toString().padStart(2, '0');

    return (
        <div className={classes['date-container'] + ' ' + props.className}>
            {props.fullDate
                ? `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`
                : `${day}.${month}.${year}`}
        </div>
    );
};

export default DateIndicator;
